
    <span
      class="account-avatar"
      #item
      [ngStyle]="{ 'background-color': bgs[type], color: colors[type] }"
      [ngClass]="'size-' + size"
      ><span class="text">{{ initials }}</span></span
    >
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/user-avatar.component.ts.UserAvatarComponent.html